module.exports = __webpack_public_path__ + "img/checkmark-error-red.f89ddf90.svg";